import React from "react";
import { Button } from "@mui/material";
import { LocalOffer } from "@mui/icons-material";


export default function KanbanEtiquetas(props) {
    const { kanban, action } = props;

    function handleClickOpen(){
        console.log('>>handleClickOpen<<')
    }
    return (
        <React.Fragment>
            <Button startIcon={<LocalOffer />} size='small'
                onClick={handleClickOpen}
            >
                Etiquetas
            </Button>
        </React.Fragment>
    )

}